import { createRoot } from "react-dom/client";
import { reportLCP } from "@/common/utils/reportLCP";
import { startWebVitals } from "@/common/utils/webVitals";
import { AppContainer } from "components/app-lite/AppContainer";

const root = createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(<AppContainer />);

reportLCP();
startWebVitals();
